import { gangtokInstance as http } from "./http-common";

const token = "";

const getDefectWiseReport = (data) => {
  return http.post("DefectCountJallipool/getDefectCount", data, {
    headers: { Authorization: "Bearer" + token },
  });
};

const JallipoolService = {
  getDefectWiseReport,
};

export default JallipoolService;
